/* eslint-disable no-unused-vars */
<template>
  <Modal
    size="medium"
    :active="true"
    :class="`bulk-dispute-modal ${
      enableSearch || bulkProcessingCompleted || closeIconVisible
        ? 'show-close-icon'
        : ''
    }`"
    @onClose="onClose()">
    <div slot="header" class="bulk-dispute-modal__header">
      <div class="bulk-dispute-modal__title-left-area">
        <p>Bulk dispute creation status</p>
        <span
          v-if="showSearchFields"
          class="bulk-dispute-modal__title-left-area__sub-title">
          Search for bulk ids to check dispute creation status
        </span>
      </div>
    </div>
    <div slot="content">
      <div class="bulk-dispute-modal__section">
        <template
          v-if="
            !isEmpty(bulkCreatedId) || !isEmpty(showBulkStatusNotification)
          ">
          <Notification
            :title="`Your create bulk dispute is ${bulkCreateStatus} for create bulk Id ${
              !isEmpty(showBulkStatusNotification)
                ? showBulkStatusNotification
                : bulkCreatedId
            }`"
            icon="check-circle"
            type="success"
            class="bulk-dispute-modal__create-bulk-notification">
          </Notification>
        </template>

        <div
          v-if="showSearchFields"
          class="bulk-dispute-modal__section__search-bulkid">
          <span>Search for bulk ids</span>
          <div class="bulk-dispute-modal__section__search-bulkid__search-area">
            <div
              class="bulk-dispute-modal__section__search-bulkid__search-area__content">
              <div
                class="bulk-dispute-modal__section__search-bulkid__search-area__content__text-input">
                <text-input
                  id="bulkid-input"
                  icon="magnifying-glass"
                  :show-clear-button="true"
                  :value="bulkIds"
                  :label-sr-only="true"
                  :error="isBulkError"
                  :error-message="bulkError"
                  placeholder="Enter bulk ids by comma seperated values"
                  @onChange="onBulkSearch"
                  @onClear="onClear"
                  @keydown="fetchDisputeDetailsByBulkIds" />
              </div>
              <Button
                label="Search bulk-id"
                class="invoice-input-button"
                appearance="primary"
                :disabled="isBulkIdsButtonDisabled"
                @onClick="fetchDisputeDetailsByBulkIds" />
            </div>
          </div>
        </div>
        <DisputeBulkTabs
          v-if="!isEmpty(bulkUpdatedInvoices) || !isEmpty(bulkFailedInvoices)"
          :bulk-created-id="bulkCreatedId"
          :bulk-updated-invoices="bulkUpdatedInvoices"
          :bulk-failed-invoices="bulkFailedInvoices"
          :bulk-processing-completed="bulkProcessingCompleted" />
        <div
          v-if="
            notFoundBulkIds && notFoundBulkIds.length && bulkProcessingCompleted
          "
          class="bulk-dispute-modal__section__not-found">
          <Notification
            type="error"
            title="Not found bulkids:"
            icon="times-circle"
            @handleIconClick="handleClickForNotFoundBulkids">
            <span>{{ notFoundBulkIds.toString() }}</span>
          </Notification>
        </div>

        <div v-if="bulkidRecordsLoading">
          <loading
            :active.sync="bulkidRecordsLoading"
            :can-cancel="false"
            :is-full-page="true"
            color="#0573ab" />
        </div>
      </div>
    </div>

    <template v-if="!showSearchFields && !showCloseIcon()" slot="footer">
      <div class="modal__footer">
        <count-down-timer
          :is-refresh-button-disabled="isRefreshButtonDisabled"
          :refresh-time-interval="30"
          @updateRefreshButtonDisabledFlag="updateRefreshButtonDisabledFlag"
          @fetchDisputeDetailsByBulkIds="fetchDisputeDetailsByBulkIds">
        </count-down-timer>
      </div>
    </template>
  </Modal>
</template>

<script>
// axios
import AxiosFetchForMsal from "@/utils/axiosForMsal";
// Actions
import { disputeActions } from "@/actions";
//helpers
import { getMsalIdToken } from "@/utils/helpers";
import { showToast } from "@/components/common/Toast";
import Loading from "vue-loading-overlay";
import Notification from "@anchor/ui-components/src/components/Notification/Notification.vue";
import DisputeBulkTabs from "@/components/DisputeBulkTabs/DisputeBulkTabs.vue";
import CountDownTimer from "@/components/CountDownTimer/CountDownTimer.vue";
import { isEmpty } from "@/utils/helpers.js";

export default {
  name: "BulkDisputeModal",
  components: {
    Loading,
    Notification,
    DisputeBulkTabs,
    CountDownTimer,
  },
  props: {
    enableSearch: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isEmpty,
      splitInvoiceIds: [],
      isInvoiceError: false,
      invoiceError: "",
      isBulkError: false,
      bulkError: "",
      notFoundInvoices: [],
      notFoundBulkIds: [],
      bulkidRecordsLoading: false,
      operationFailedInvoices: [],
      bulkButtonDisable: false,
      pollingInterval: null,
      bulkIds: "",
      bulkUpdatedInvoices: [],
      bulkFailedInvoices: [],
      bulkProcessingCompleted: false,
      bulkCreatedId: localStorage.getItem("bulk_create_id"),
      isRefreshButtonDisabled: true,
      showBulkStatusNotification: "",
      closeIconVisible: false,
    };
  },
  computed: {
    isBulkIdsButtonDisabled() {
      return !this.bulkIds?.length ? true : false;
    },
    showSearchFields() {
      return this.enableSearch;
    },
    bulkCreateStatus() {
      return this.bulkProcessingCompleted ? "completed" : "in progress";
    },
    remainingPathColor() {
      return "green";
    },
  },

  mounted() {
    if (!isEmpty(localStorage.getItem("bulk_create_id"))) {
      setTimeout(() => {
        this.closeIconVisible = true;
      }, 1000 * 60 * 5);
    }
    if (this.bulkCreatedId && !this.enableSearch)
      this.fetchDisputeDetailsByBulkIds();
  },
  methods: {
    showCloseIcon() {
      return this.enableSearch || this.bulkProcessingCompleted;
    },
    onClose() {
      this.$emit("onModalClose");
    },
    updateRefreshButtonDisabledFlag() {
      this.isRefreshButtonDisabled = false;
    },
    onClear() {
      if (this.bulkIds) {
        this.bulkIds = "";
      }
    },
    handleClickForNotFoundBulkids() {
      this.notFoundBulkIds = [];
    },
    onBulkSearch(e) {
      this.bulkIds = e.target.value;
    },
    bulkIdsFieldCleanup() {
      let value = this.bulkIds?.split(/\s+/)?.join(",") || "";
      let valueArr = value?.split(",")?.filter((item) => item) || [];
      value = valueArr.join(",");
      value = value.replace(/^,/, "");
      value = value.replace(/,$/, "");
      return value;
    },
    async fetchDisputeDetailsByBulkIds() {
      this.bulkidRecordsLoading = true;
      let errorMessage = "";
      this.bulkUpdatedInvoices = [];
      this.bulkFailedInvoices = [];
      this.notFoundBulkIds = [];
      this.showBulkStatusNotification = "";
      const msalToken = await getMsalIdToken(this);
      let promiseArray = [];
      const BULK_ID_LIMIT = 25;
      let newBulkIds = [];
      this.bulkIds = this.bulkIdsFieldCleanup();
      newBulkIds = this.isEmpty(this.bulkIds) ? [] : this.bulkIds.split(",");

      if (isEmpty(this.bulkIds) && !isEmpty(this.bulkCreatedId)) {
        newBulkIds.push(this.bulkCreatedId);
      }
      const noOfApiCalls = newBulkIds?.length / BULK_ID_LIMIT;
      for (let i = 0; i < noOfApiCalls; i++) {
        const endSlice =
          newBulkIds.length < (i + 1) * BULK_ID_LIMIT
            ? newBulkIds.length
            : (i + 1) * BULK_ID_LIMIT;
        const startSlice = i * BULK_ID_LIMIT;
        promiseArray.push(
          disputeActions.getStatusBulkDispute(
            newBulkIds?.slice(startSlice, endSlice),
            msalToken
          )
        );
      }

      let newBulkUpdatedInvoices = [];
      let hasError = false;
      let newBulkFailedInvoices = [];
      // Parallel API call's
      await Promise.allSettled(
        promiseArray?.map((endpoint) => AxiosFetchForMsal(endpoint))
      )
        .then((res) => {
          res.forEach((item) => {
            if (item.status === "rejected") {
              hasError = true;
              errorMessage = item.reason;
              this.bulkidRecordsLoading = false;
              return false;
            }
            const data = item?.value?.data?.response || [];

            this.bulkProcessingCompleted =
              item?.value?.data?.bulkProcessingCompleted;
            if (!isEmpty(this.bulkIds) && !isEmpty(data))
              this.showBulkStatusNotification = this.bulkIds;
            if (isEmpty(data) && item?.value?.config?.headers?.["bulk-id"]) {
              this.notFoundBulkIds = [
                ...this.notFoundBulkIds,
                item?.value?.config?.headers?.["bulk-id"],
              ];
              this.bulkidRecordsLoading = false;
              return false;
            } else {
              data.length > 0 &&
                data.forEach((item) => {
                  if (item?.status === "FAILED") {
                    newBulkFailedInvoices.push(item);
                  } else if (item?.status === "SUCCESS") {
                    newBulkUpdatedInvoices.push(item?.disputeCase);
                  }
                });
            }
          });
        })
        .catch((e) => {
          console.error("e", e);
          showToast("error", "Failed to fetch data");
          return false;
        });
      this.bulkUpdatedInvoices = [
        ...new Set(this.bulkUpdatedInvoices?.concat(newBulkUpdatedInvoices)),
      ];
      this.bulkFailedInvoices = [
        ...new Set(this.bulkFailedInvoices?.concat(newBulkFailedInvoices)),
      ];
      if (
        newBulkUpdatedInvoices.length === 0 &&
        newBulkFailedInvoices.length === 0 &&
        this.bulkProcessingCompleted
      ) {
        showToast("error", "No data found");
      }
      if (!this.isRefreshButtonDisabled) {
        this.isRefreshButtonDisabled = true;
      }

      if (hasError) {
        showToast("error", errorMessage);
        this.closeIconVisible = true;
        return false;
      }
      this.bulkidRecordsLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.bulk-dispute-modal {
  padding: 12px;
  display: flex;
  flex-direction: column;
  @media (min-width: 1400px) {
    padding: 24px 48px;
  }
  &__header {
    display: flex;
  }
  &__title-left-area {
    margin-top: 8px;
    h3 {
      font-family: "Maersk Headline";
      font-style: normal;
      font-weight: 400;
      font-size: 26px;
      line-height: 32px;
      color: var(--Gray-900);
    }
    &__sub-title {
      margin-top: 8px;
      font-family: "Maersk Text";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: var(--Gray-700);
    }
  }
  &__section {
    min-height: 120px;
    background: var(--Gray-50);
    &__search-bulkid {
      padding-bottom: 24px;
      span {
        font-family: "Maersk Headline";
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 24px;
        color: var(--Blue-900-Darkest);
      }
      &__search-area {
        display: flex;
        justify-content: space-between;
        margin-top: 8px;
        &__content {
          display: flex;
          flex: 1;
          &__text-input {
            width: 70%;
          }
        }
      }
    }
    &__not-found,
    &__failed {
      padding-bottom: 20px;
      width: 70%;
      span {
        font-family: "Maersk Text";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: var(--Blue-900-Darkest);
      }
    }
    &__bulk-update {
      display: flex;
      justify-content: space-between;
      margin-top: 12px;
      span {
        font-family: "Maersk Text";
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
      }
    }
    &__configure-tags {
      display: flex;
      justify-content: space-between;
      a {
        min-width: 50px;
      }
    }
  }
  &__create-bulk-notification {
    margin-bottom: 12px;
  }
  .modal__footer {
    z-index: 1;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
<style lang="scss">
.bulk-dispute-modal {
  .modal--medium {
    height: 650px;
    width: 1000px;
    .modal__header__close {
      display: none;
    }
  }
}
.show-close-icon {
  .modal--medium {
    .modal__header__close {
      display: block;
    }
  }
}
.bulk-dispute-modal__fullscreen {
  padding: 0px !important;
  .modal--medium {
    display: block;
    padding: 0px;
    width: 100%;
    height: 100%;
  }
}
.bulk-dispute-modal {
  #invoice-input {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
  .invoice-input-button {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  .refresh-button {
    max-height: 42px;
    margin-left: 1rem;
  }
  .dispute-reason {
    .form-input__field {
      max-height: 40px !important;
      width: 180px;
    }
  }
}
</style>
